import React from 'react';
import { FaGraduationCap, FaUsers, FaUserGraduate, FaUserFriends, FaHandshake, FaEnvelope, FaMapMarkedAlt } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/StudentTypeCard.css';

const StudentTypeCard = ({ studentType, onGetConnectedClick }) => {
  const getIcon = (iconType) => {
    switch (iconType) {
      case 'first-year':
        return <FaGraduationCap />;
      case 'returning':
        return <FaUsers />;
      case 'prospective':
        return <FaMapMarkedAlt />;
      case 'grad':
        return <FaUserGraduate />;
      case 'parents':
        return <FaUserFriends />;
      case 'alumni':
        return <FaHandshake />;
      default:
        return <FaUsers />;
    }
  };

  const handleClick = (e, link) => {
    // Check if this is a "Get Connected" link and we have a custom handler
    if (onGetConnectedClick && link === '/get-connected') {
      e.preventDefault();
      onGetConnectedClick();
      return;
    }
    
    if (link && link.startsWith('http')) {
      e.preventDefault();
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const renderContact = (contact) => {
    if (!contact) return null;
    
    // Check if contact contains an email
    const emailMatch = contact.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/);
    if (emailMatch) {
      const email = emailMatch[1];
      const name = contact.split(':')[0];
      return (
        <div className="student-type-card-contact">
          <strong>{name}:</strong> {email.split('@')[0]}@jh.edu
          <a 
            href={`mailto:${email}`}
            className="student-type-card-email-icon"
            title={`Email ${name}`}
          >
            <FaEnvelope />
          </a>
        </div>
      );
    }
    
    return (
      <div className="student-type-card-contact">
        <strong>Contact:</strong> {contact}
      </div>
    );
  };

  return (
    <div className="student-type-card">
      <div className="student-type-card-header">
        <div className="student-type-card-icon">
          {getIcon(studentType.icon)}
        </div>
        <div className="student-type-card-title-section">
          <h3 className="student-type-card-title">{studentType.title}</h3>
          <p className="student-type-card-subtitle">{studentType.subtitle}</p>
        </div>
      </div>
      
      <RichText value={studentType.description} className="student-type-card-description" />
      
      {studentType.contact && renderContact(studentType.contact)}
      
      <div className="student-type-card-links">
      <a 
        href={studentType.link} 
        className="student-type-card-link"
          onClick={(e) => handleClick(e, studentType.link)}
        target={studentType.link.startsWith('http') ? "_blank" : undefined}
        rel={studentType.link.startsWith('http') ? "noopener noreferrer" : undefined}
      >
        {studentType.linkText}
      </a>
        
        {studentType.secondaryLink && (
          <a 
            href={studentType.secondaryLink} 
            className="student-type-card-link secondary"
            onClick={(e) => handleClick(e, studentType.secondaryLink)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {studentType.secondaryLinkText}
          </a>
        )}
      </div>
    </div>
  );
};

export default StudentTypeCard; 